import React from "react";
import "./page.css";

const About = () => {
    const title = (
        <>
            About
        </>  
    );
    
    const subtitles = {
        
    };

    const paraText1 = (
        <>
            This project is financed by {" "}
            <a
                href="https://www.pepr-cybersecurite.fr/projet/defmal/"
                className="page-link"
                target="_blank"
                rel="noopener noreferrer"
            >
                DefMal
            </a>{" "}
            ,{" "}
            <a
                className="page-link"
                href="https://www.pepr-cybersecurite.fr/le-pepr/"
                target="_blank"
                rel="noopener noreferrer"
                title="Programme et équipements prioritaires de recherche Cybersécurité"
            >
                PEPR Cybersecurity
            </a>{" "}
            .
            <br />
            <br />
        </>
    );
   
    const paraText2 = (
        <>
            The deployment of the PoneyPots uses the {" "}
            <a
                href=" https://ursid.readthedocs.io/"
                className="page-link"
                target="_blank"
                rel="noopener noreferrer"
            >
            URSID
            </a>{" "}
            software.
            <br/>
            All experiments take place at the High-Security Laboratory {" "}
            <a
                className="page-link"
                href="https://www.lhs-rennes.fr/"
                target="_blank"
                rel="noopener noreferrer"
            >
            High-Security Laboratory
            </a> in Rennes. {" "}
        </>
    );

    return (
        <div className="page">
            <div className="page-title">
                <h1>{title}</h1>
            </div>
            <br />
            <br />
            <br />

            <div className="page-item-normal">
                <p>{paraText1}</p>
            </div>

            <div className="page-item">
                <p>{paraText2}</p>
            </div>

            <br />
            <br />

        </div>
                
    );
};

export default About;
